import { Dialog } from '@mui/material';
import { styled } from '@mui/material/styles';
export const CustomDialog = styled(Dialog)(({
  theme
}) => ({
  '& .MuiDialog-paper': {
    borderRadius: '1rem',
    padding: '0 24px 24px 24px',
    width: '25rem',
    maxHeight: '37.5rem',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      margin: 0,
      padding: '0 12px 12px 12px'
    }
  }
}));
export const dialogStyles = {
  closeButton: {
    position: 'absolute',
    right: 7,
    top: '0.9375rem',
    color: theme => theme.palette.grey[500]
  },
  dialogTitle: {
    margin: 0,
    padding: 3,
    position: 'relative'
  },
  treatmentBox: (isSelected: boolean) => theme => ({
    padding: 1.5,
    marginBottom: 2,
    border: isSelected ? `2px solid ${theme.palette.grey[500]}` : `1px solid ${theme.palette.grey[200]}`,
    borderRadius: '0.5rem',
    cursor: 'pointer',
    '&:hover': {
      borderColor: theme.palette.grey[500]
    }
  })
};